function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMenui = function SvgMenui(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M18 12c0 .442-.37.8-.828.8H6.828C6.371 12.8 6 12.442 6 12s.371-.8.828-.8h10.344c.458 0 .828.358.828.8zm0 4.2c0 .442-.37.8-.828.8H6.828C6.371 17 6 16.642 6 16.2s.371-.8.828-.8h10.344c.458 0 .828.358.828.8zm0-8.4c0 .442-.37.8-.828.8H6.828C6.371 8.6 6 8.242 6 7.8s.371-.8.828-.8h10.344c.458 0 .828.358.828.8z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMenui);
export default ForwardRef;